import { setPublicPath } from 'systemjs-webpack-interop'

setPublicPath('@dwid/reports', 2)
